<template>
  <div class="flex items-center my-5 md:my-0 cursor-pointer" @click="navigateBack">
    <ChevronLeftIcon class="text-brand-green w-5 h-5 mr-1" />
    <p class="text-sm">Back to documents</p>
  </div>
  <div class="flex flex-col md:flex-row mb-5">
    <div class="flex flex-1 flex-col">
      <div
        class="flex flex-col md:min-w-[300px] md:w-1/3 mx-auto py-3 px-10 bg-white rounded items-center"
      >
        <h2 class="py-1">Create Document</h2>
        <p class="text-brand-mid-gray py-2">{{ currentStep }}</p>
        <p class="text-brand-mid-gray py-2">{{ step }} of 2</p>
      </div>
    </div>
  </div>

  <router-view />
</template>
<script>
import { ChevronLeftIcon } from "@heroicons/vue/outline"

import { mapGetters } from "vuex"

export default {
  components: {
    ChevronLeftIcon
  },
  mounted() {
    if (this.$route.name === "dashboard_new_document") {
      this.$router.push({ name: "dashboard_new_document_name" })
    }
  },
  computed: {
    ...mapGetters(["getCurrentUser"]),
    step() {
      if (this.$route.name === "dashboard_new_document_fields") {
        return 2
      }
      return 1
    },
    currentStep() {
      if (this.$route.name === "dashboard_new_document_name") {
        return "Upload files"
      }
      if (this.$route.name === "dashboard_new_document_fields") {
        return "Place fields"
      }
      return ""
    }
  },
  methods: {
    navigateBack() {
      this.$router.push({ name: "dashboard_documents" })
    }
  }
}
</script>
